import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseCadouhApiService } from '../../../shared/services/base-cadouh-api.service';
import { PaginatedVendorReviews } from '../../../shared/models/paginated-vendor-reviews';
import { RatingCount } from '../../../shared/models/rating-count';
import { LimitOffsetPagination } from '../../../shared/models/limit-offset-pagination';

@Injectable({
  providedIn: 'root'
})
export class ReviewsApiService extends BaseCadouhApiService {

  getVendorReviews(pagination: LimitOffsetPagination, status:string = ''): Observable<PaginatedVendorReviews> {
    return this.http.get<PaginatedVendorReviews>(`${this.baseUrl}/giftshop/admin/vendor_reviews/?limit=${pagination.limit}&offset=${pagination.offset}`, { headers: this.getRequestHeadersWithToken() });
  }


  getVendorReviewsSummary(): Observable<RatingCount[]>{
    return this.http.get<RatingCount[]>(`${this.baseUrl}/giftshop/admin/vendor_reviews_data/`, { headers: this.getRequestHeadersWithToken() });
  }
}
